// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CqB1C","top":"styles_top__1a2Xi"};